/* Angular */
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './app-root.component.html',
    styleUrls: ['./app-root.component.scss'],
})
export class AppRootComponent {}
